module.exports = __webpack_public_path__ + "img/xiting-club.35950af0.jpg";